import { render } from "./OtherHealthPersonnelPage.vue?vue&type=template&id=03db0c1f&scoped=true"
import script from "./OtherHealthPersonnelPage.vue?vue&type=script&lang=js"
export * from "./OtherHealthPersonnelPage.vue?vue&type=script&lang=js"

import "./OtherHealthPersonnelPage.vue?vue&type=style&index=0&id=03db0c1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03db0c1f"]])

export default __exports__